import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { Hotel, STATUSRESERVA } from "src/app/model";
import { HotelService, Util } from "src/app/services";
import { ModalComponent } from "../../modal/modal.component";

@Component({
  selector: "app-hotel-card",
  standalone: false,
  templateUrl: "./hotel-card.component.html",
  styleUrl: "./hotel-card.component.scss",
})
export class HotelCardComponent implements OnInit {
  @Input() hotel: Hotel & { carregando: boolean };
  @Input() quantidadeItens: { aereo: number; aereoConsolidacao: boolean; hotel: number; servico: number };
  @Input() statusOrcamento: number;
  @Input() agenteEmpresaId: number = null;
  @Input() empresaId: number = null;
  @Input() LiberarVoucher: boolean = false;
  @Input() termometroValido: boolean = false;
  @Input() perfilRoot: boolean = false;
  @Input() cardSimplificado: boolean = false;
  @Input() hotelId: number;
  @Input() idadeInvalida: boolean = false;
  @Input() cardItem: any;

  @Output() verificaIdadeValida: EventEmitter<void> = new EventEmitter<void>();
  @Output() imprimirVoucherEmitter: EventEmitter<Hotel> = new EventEmitter();
  @Output() removerHotelEmitter: EventEmitter<Hotel> = new EventEmitter();
  @Output() carregarObjetoEmitter: EventEmitter<number> = new EventEmitter();
  @Output() carregandoEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() atualizarHotelEmitter: EventEmitter<number> = new EventEmitter();

  @ViewChild("modalReserva") modalReserva: ModalComponent;

  mensagemSucessoHotel: string = "";
  mensagensErroHotel: string[] = [];

  carregandoObj: boolean = false;
  removeUltimoHotel: boolean = false;

  constructor(private hotelService: HotelService, private utilService: Util) {}

  ngOnInit(): void {
    const permi = window.localStorage.getItem("permission");
    if (permi != null) {
      var permissoes = JSON.parse(atob(permi));

      this.removeUltimoHotel = permissoes.indexOf("remove_ultimo_hotel") > -1 || permissoes.indexOf("admin") > -1 || permissoes.indexOf("root") > -1;
    }

    if (this.cardSimplificado) {
      if (this.cardItem != null && this.cardItem != undefined) {
        this.hotel = this.cardItem;
        this.hotel.carregando = false;
      } else {
        this.carregarHotel();
      }
    }
  }

  carregarHotel() {
    this.hotelService.buscarHotelPorId(this.hotelId).subscribe(
      (dados) => {
        this.hotel = dados;
        this.hotel.carregando = false;
      },
      (erro) => {
        this.hotel.carregando = false;
        this.mensagensErroHotel.push(...this.mensagensErroHotel, this.utilService.errorHandler(erro));
        alert(this.mensagensErroHotel);
      }
    );
  }

  noites(dataInicio, dataFim) {
    dataInicio = moment(dataInicio);
    dataFim = moment(dataFim);
    return dataFim.diff(dataInicio, "days");
  }

  imprimirVoucher() {
    this.imprimirVoucherEmitter.emit(this.hotel);
  }

  atualizarHotel(hotel) {
    var cidade = this.hotel.Cidade;
    var webService = this.hotel.WebService;
    hotel.Cidade = cidade;
    hotel.WebService = webService;
    this.hotel = hotel;
    this.carregarObjetoEmitter.emit(this.hotel.ReservaId);
  }

  atualizarStatusHotel() {
    this.hotel.carregando = true;
    const statusAtual = this.hotel.Status;
    this.hotelService.atualizarStatusHotel(this.hotel).subscribe(
      (dados) => {
        this.hotel = dados;
        this.atualizarHotel(this.hotel);
        if (this.hotel.Status === statusAtual) {
          this.mensagemSucessoHotel = `Hotel ${this.hotel.Nome} segue com o mesmo status no fornecedor!`;
          alert(this.mensagemSucessoHotel);
        } else {
          // tslint:disable-next-line:max-line-length
          this.mensagemSucessoHotel = `Hotel ${this.hotel.Nome} teve o Status Alterado de ${this.utilService.getEnumLabel(STATUSRESERVA, statusAtual)} para ${this.utilService.getEnumLabel(STATUSRESERVA, this.hotel.Status)}!`;
          alert(this.mensagemSucessoHotel);
        }

        this.hotel.carregando = false;
      },
      (erro) => {
        this.hotel.carregando = false;
        this.mensagensErroHotel.push(...this.mensagensErroHotel, this.utilService.errorHandler(erro));
        alert(this.mensagensErroHotel);
      }
    );
  }

  cancelarHotel() {
    let mensagem = [];

    if (confirm("Confirmar cancelamento do hotel?")) {
      this.carregandoObj = true;

      // this.limparMensagensHotel();
      this.hotelService.cancelarHotel(this.hotel).subscribe(
        (dados) => {
          this.hotel = dados;
          mensagem.push("Cancelamento efetivado!");
          this.carregarObjetoEmitter.emit(this.hotel.ReservaId);
          alert(mensagem);
        },
        (erro) => {
          this.mensagensErroHotel.push(...this.mensagensErroHotel, this.utilService.errorHandler(erro));
          alert(mensagem);
          this.carregandoObj = false;
        }
      );
    }
  }

  removerHotel() {
    if (confirm("Confirmar exclusão do hotel?")) {
      this.carregandoObj = true;

      // this.limparMensagensHotel();
      if (this.termometroValido) {
        alert(this.utilService.fazerTraducao("Necessário retornar o valor do termômetro para padrão antes de remover esse item."));
        this.carregandoObj = false;
        return;
      }

      if (
        !this.perfilRoot &&
        !this.removeUltimoHotel &&
        this.quantidadeItens.aereo > 0 &&
        // !this.quantidadeItens.aereoConsolidacao &&
        this.quantidadeItens.hotel === 1 &&
        (this.quantidadeItens.servico == null || this.quantidadeItens.servico === 0)
      ) {
        alert("É necessário manter pelo menos um item além do aéreo !");
      } else {
        this.hotelService.removerHotel(this.hotel).subscribe(
          (dados) => {
            alert("Hotel removido com sucesso");
            // this.mensagemSucessoHotel = `Hotel ${dados.Id} removido com sucesso!`
            this.atualizarHotelEmitter.emit(this.hotel.Id);
            this.carregarObjetoEmitter.emit(this.hotel.ReservaId);
            this.carregandoObj = false;
          },
          (erro) => {
            let mensagem = this.utilService.errorHandler(erro, "remover hotel");
            alert(mensagem);
            this.carregandoObj = false;
          }
        );
      }
    }
  }

  validaSePodeReservar() {
    this.verificaIdadeValida.emit();
    if (this.idadeInvalida) {
      this.mensagensErroHotel.push(this.utilService.fazerTraducao("Verifique a Idade dos passageiros."));
      return;
    } else {
      this.modalReserva.open();
    }
  }
}
